<ul #nav="ngbNav" class="nav-pills h-100" [(activeId)]="activeType" ngbNav orientation="vertical">
  <ng-container *ngIf="showBrands">
    <li [ngbNavItem]="'brand'">
      <a [queryParams]="{ page: 1 }" ngbNavLink routerLink="{{ routingBasePath }}/brand">
        <span class="type-label"> {{ "Brands" | translate }} / {{ "Companies" | translate }} </span>

        <span *ngIf="brandCount$" class="count">
          {{ brandCount$ | async }}
        </span>
      </a>
    </li>

    <li class="nav-item-separator"></li>
  </ng-container>

  <li *ngFor="let type of types" [disabled]="type.disabled" [ngbNavItem]="type.value.toLowerCase()">
    <a [queryParams]="{ page: 1 }" ngbNavLink routerLink="{{ routingBasePath }}/{{ type.value.toLowerCase() }}">
      <span class="type-label">
        {{ type.label }}
      </span>

      <span *ngIf="type.count" class="count">
        {{ type.count | async }}
      </span>

      <span class="type-collapse-toggle">
        <fa-icon
          *ngIf="activeType !== type.value.toLowerCase() && uncollapsedTypes.includes(type.value)"
          (click)="toggleCollapseType($event, type.value)"
          icon="angle-up"
        ></fa-icon>

        <fa-icon
          *ngIf="activeType !== type.value.toLowerCase() && !uncollapsedTypes.includes(type.value)"
          (click)="toggleCollapseType($event, type.value)"
          icon="angle-down"
        ></fa-icon>

        <fa-icon *ngIf="activeType === type.value.toLowerCase()" icon="circle-dot"></fa-icon>
      </span>
    </a>

    <ul
      #subnav="ngbNav"
      *ngIf="showSubNavigation && (uncollapsedTypes.includes(type.value) || activeType === type.value.toLowerCase())"
      class="nav-pills"
      [(activeId)]="activeSubNav"
      ngbNav
      orientation="vertical"
    >
      <ng-container *ngIf="currentUser$ | async as currentUser">
        <li *ngIf="currentUser | isEquipmentModerator" ngbNavItem="pending-review-explorer">
          <a ngbNavLink routerLink="/equipment/pending-review-explorer/{{ type.value.toLowerCase() }}">
            <span class="type-label">{{ "Pending review" | translate }}</span>
            <span *ngIf="type.pendingReviewCount" class="count">{{ type.pendingReviewCount | async }}</span>
          </a>
        </li>

        <li ngbNavItem="followed-explorer">
          <a ngbNavLink routerLink="/equipment/followed-explorer/{{ type.value.toLowerCase() }}">
            <span class="type-label">{{ "Followed" | translate }}</span>
            <span *ngIf="type.followedCount" class="count">{{ type.followedCount | async }}</span>
          </a>
        </li>
      </ng-container>

      <li [class.has-pending-edits]="(type.pendingEditCount | async) > 0" ngbNavItem="pending-edit-explorer">
        <a ngbNavLink routerLink="/equipment/pending-edit-explorer/{{ type.value.toLowerCase() }}">
          <span class="type-label">{{ "Pending edit" | translate }}</span>
          <span *ngIf="type.pendingEditCount" class="count pending-edit-count">{{
            type.pendingEditCount | async
          }}</span>
        </a>
      </li>
    </ul>
  </li>

  <ng-container *ngIf="showContributors">
    <li class="nav-item-separator"></li>

    <li [ngbNavItem]="'contributors'">
      <a ngbNavLink routerLink="{{ routingBasePath }}/contributors">
        <span class="type-label">
          {{ "Contributors" | translate }}
        </span>

        <span *ngIf="contributorCount$" class="count">
          {{ contributorCount$ | async }}
        </span>
      </a>
    </li>
  </ng-container>
</ul>
